import styles from '../styles.module.scss';

import React, {useEffect, useRef, useState} from "react";
import {getFormattedSeatValue, sanitizeHtml} from "../../helpers/helpers";

interface ButtonOptionProps {
    name: string,
    id: string,
    value: string,
    onChange: any,
    price: string,
    comparePrice: string,
    checked: boolean,
    display: boolean,
    enabled: boolean,
    showSavingsIcon: boolean,
    customClass?: string,
    diffPrefix?: string,
    diffSuffix?: string,
    type: 'radio' | 'checkbox',
    customCompatibility: string,
    currentAppData?: any,
    subtitle?: string,
    // Overrides the label shown/formatted as the title, while `value` stays
    // wired to the actual <input value>/onChange identity (e.g. an addon key
    // that doesn't match the seat-name formatting in getFormattedSeatValue).
    displayLabel?: string
}

const ButtonOption: React.FC = (props: ButtonOptionProps) => {

    const {
        value,
        subtitle: computedSubtitle,
        diff,
        comparePrice
    } = getFormattedSeatValue(props.displayLabel ?? props.value, props.price, props.comparePrice, props.customCompatibility, props.currentAppData);

    const subtitle = props.subtitle !== undefined ? props.subtitle : computedSubtitle;

    const styles_override = {}
    // console.log('button', props.name, props.value, props.display);
    if (props.display === false || props.enabled === false) {
        styles_override['display'] = 'none';
    }

    let diffPrefix = props.diffPrefix;
    let diffSuffix = props.diffSuffix;

    if (window.scs_black_friday_2025) {
        diffPrefix = 'Save ';
        diffSuffix = ' Today!';
    }

    return (
        <div
            className={`${styles.button_option} ${window.scs_custom_style ? styles.style01 : ''} ${props.checked ? styles.checked : ''}
        ${props.customClass ? props.customClass : ''}
        `}
            style={styles_override}>
            <label htmlFor={props.id}>
                <div className={`${styles.form_control}`}>
                    <input onChange={props.onChange} type={props.type} name={props.name}
                           value={props.value} id={props.id} checked={props.checked}/>
                </div>
                <div className={`${styles.content_wrapper}`}>
                    <div className={`${styles.title_wrapper}`}>
                        {window.scs_black_friday_2025 ? <div className={`${styles.title_label}`} dangerouslySetInnerHTML={{__html: sanitizeHtml(window.scs_promo_special_text)}}></div>: ''}
                        <div className={`${styles.title}`}>
                            {`${value}`}
                        </div>
                        <div className={`${styles.sub_title}`}>
                            {`${subtitle}`}
                        </div>
                    </div>
                    <div className={`${styles.priceContainer}`}>
                        {window.scs_black_friday_2025 ?
                            <div className={`${styles.special_price_title}`}>{window.scs_special_price_title || ''}</div> : ''}
                        <div className={`${styles.innerPriceContainer}`}>
                            {props.comparePrice && parseFloat(props.comparePrice.replace(/[^0-9.]/g, '')) > 0 ? <div className={`${styles.btn_savings}`} data-testid={`option-savings-${props.id}`}>{props.showSavingsIcon ? (
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
                                     fill="none">
                                    <path
                                        d="M11 0.00012207H6.84364C6.56869 0.00012207 6.1844 0.159408 5.99014 0.353528L0.291817 6.05182C-0.0972722 6.44047 -0.0972722 7.07767 0.291817 7.46585L4.53468 11.7086C4.92289 12.0972 5.55947 12.0972 5.94827 11.7081L11.6466 6.01071C11.8407 5.81662 12 5.43172 12 5.15736V1.00016C12 0.450265 11.5498 0.00012207 11 0.00012207ZM8.99984 4.00014C8.44754 4.00014 7.9998 3.55193 7.9998 3.0001C7.9998 2.44736 8.44754 2.00006 8.99984 2.00006C9.55214 2.00006 10 2.44736 10 3.0001C10.0001 3.55193 9.55214 4.00014 8.99984 4.00014Z"
                                        fill="white"/>
                                </svg>) : ''}{diffPrefix}{diff}{diffSuffix}</div> : ''}
                            <div className={`${styles.price_wrapper}`}>
                                {props.comparePrice && parseFloat(props.comparePrice.replace(/[^0-9.]/g, '')) > 0 ? (<div className={`${styles.compare_price}`} data-testid={`option-compare-price-${props.id}`}>
                                    {comparePrice}
                                </div>) : ''}
                                {props.price ? (<div className={`${styles.price}`} data-testid={`option-price-${props.id}`}>
                                    {props.price}
                                </div>) : ''}
                            </div>
                        </div>
                    </div>
                </div>

            </label>
        </div>
    );
};

export default ButtonOption;
